<template>
    <div class="core-ability-box">
        <section-title main="我们的核心能力" sub="赋能机构，把优质教育资源带进千家万户"></section-title>
        <div class="content">
            <div class="content-item" v-for="(item, index) in objData" :key="index">
                <img class="core-image" v-if="item.isImg" :src="item.imgUrl">
                <div v-else class="mes-box">
                    <div class="detail-box">
                        <p class="title">{{item.title}}</p>
                        <p class="mes" v-html="item.mes"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { coreAbilityData } from '@/const'
export default {
    data () {
        return {
            objData: coreAbilityData
        }
    }
}
</script>
<style lang="scss" scoped>
.core-ability-box{
    .content{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .content-item{
            width: 50%;
            height: 196px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
            .core-image{
                width: 100%;
                height: 196px;
            }
            .mes-box{
                display: flex;
                justify-content: center;
                align-items: center;
                background: #0182FF;
                width: 100%;
                height: 100%;
                .detail-box{
                    width: 160px;
                    .title{
                        font-size:18px;
                        font-family:PingFangSC-Medium,PingFang SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        line-height:25px;
                    }
                    .mes{
                        font-size:10px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        line-height:14px;
                    }
                }
            }
        }
    }
}
</style>